class SubmenuHandler {
  constructor() {
    this.open_class = "nav__sublist-container--open";
    this.init();
  }

  init() {
    this.previous = null;
    const menu = document.querySelector(".nav__list");
    if (window.innerWidth < 1280) {
      const firstItem = menu.querySelector(".nav__item");
      const firstSubmenu =
        firstItem && firstItem.querySelector(".nav__sublist-container");
      if (firstSubmenu) {
        firstSubmenu.classList.add(this.open_class);
      }
    }
    addEventListener("click", (ev) => {
      const groupToggle = ev.target.closest("button.nav__sublist-header");
      if (groupToggle) {
        if (window.innerWidth < 1280) {
          groupToggle
            .closest(".nav__sublist-group")
            .classList.toggle("nav__sublist-group--open");
        }
        return;
      }
      if (ev.target.classList.contains("nav__button")) {
        const submenu = ev.target.nextElementSibling;
        if (submenu.classList.contains(this.open_class)) {
          submenu.classList.remove(this.open_class);
          document.querySelector("main").classList.remove("blur");
          if (window.innerWidth >= 1280) {
            document.body.removeAttribute("style");
          }
          return;
        } else {
          if (window.innerWidth >= 1280) {
            this.closeOpenMenu();
            document.body.style.overflow = "hidden";
          }
          submenu.classList.add(this.open_class);
          document.querySelector("main").classList.add("blur");
        }
      } else {
        this.closeOpenMenu();
      }
    });
    addEventListener("keydown", (ev) => {
      if (ev.key === "Escape") {
        this.closeOpenMenu();
      }
    });
  }

  closeOpenMenu() {
    let open_menu = document.querySelector(`.${this.open_class}`);
    if (open_menu) {
      document.querySelector("main").classList.remove("blur");
      if (window.innerWidth >= 1280) {
        open_menu.classList.remove(this.open_class);
        document.body.removeAttribute("style");
      }
    }
    document.querySelectorAll(".nav__sublist-group--open").forEach((g) => {
      g.classList.remove("nav__sublist-group--open");
    });
  }
}

export default SubmenuHandler;
